import { Box, Flex } from '@chakra-ui/react';
import { TableOfContents } from './table-of-contents';
import { SaneBlockChakra } from '@components';
import { DocsTemplateContent } from '@types';
import { PageContainer } from '../page-container';
import { MDXRemoteSerializeResult } from 'next-mdx-remote';
import { HeadingItem } from '@lib/docs/plugins/remark-plugin-headings/remark-plugin-headings';
import { MDXContainer } from './mdx-container';

type Props = {
  content: DocsTemplateContent;
  mdx?: MDXRemoteSerializeResult & {
    headings: HeadingItem[];
    editLink: string;
    lastUpdated: string | null;
  };
};

export function DocsTemplate({ content, mdx }: Props): JSX.Element {
  const h1 = mdx?.headings.find(heading => heading.level == 1);

  return (
    <PageContainer>
      <Flex py={12} mx="auto" justify="center" color="var(--primaryTextColor)">
        <Box
          px={{ base: 6, lg: 10 }}
          sx={{
            maxW: 'full',

            // Chakra's `xl` breakpoint; table of contents appears here
            '@media screen and (min-width: 1280px)': {
              maxW: 'container.sm'
            },

            '@media screen and (min-width: 1400px)': {
              maxW: 'container.md'
            }
          }}
        >
          {mdx ? (
            <MDXContainer mdx={mdx} />
          ) : (
            <SaneBlockChakra blocks={content?.body} />
          )}
        </Box>

        <TableOfContents
          content={content?.body}
          headings={mdx?.headings}
          editLink={mdx?.editLink}
        />
      </Flex>
    </PageContainer>
  );
}
